import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';

@Component({
    selector: 'app-dccs-view',
    templateUrl: './dccs-view.component.html',
    styleUrls: ['./dccs-view.component.scss']
})
export class DccsViewComponent implements OnInit {

    constructor(private http: HttpService) { }
    showType: any = null;
    data: any = {};
    isStarted = 0;

    async getData(name: string): Promise<void> {
        this.data.info = '';
        const r = await this.http.Get('info/' + name, {});
        this.data = r.response?.result || {};
        if (this.data.quiz_status > -1) {
            this.isStarted = this.data.quiz_status;
        }
    }

    ngOnInit(): void {
        this.getData('DCCS');
    }

}
